module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "featured"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 featured-slogan"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('heading.slogan')))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.btnUrl
    }
  }, [_c('button', {
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t('heading.cta')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 featured-stats"
  }, [_c('ul', [_c('li', [_c('h3', [_vm._v(_vm._s(_vm.$t('stats.availableMaps')))]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("insert_chart")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.availableMaps))])])]), _vm._v(" "), _c('li', [_c('h3', [_vm._v(_vm._s(_vm.$t('stats.lastUpdate')))]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("today")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("dateDay")(_vm.lastActivity)) + "-" + _vm._s(_vm._f("dateMonth")(_vm.lastActivity, _vm.selectedLang)) + "-" + _vm._s(_vm._f("dateYear")(_vm.lastActivity)))])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56335d10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gallery/components/gallery-featured/gallery-featured.vue
// module id = 309
// module chunks = 0